const ticketStorage = "tickets_attachments";
var QbIdb = {
    async getDb() {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open('qbdb', 2);
            
            request.onerror = e => {
                console.log('Error opening db', e);
                reject('Error');
            };
        
            request.onsuccess = e => {
                resolve(e.target.result);
            };
            
            request.onupgradeneeded = e => {
                let db = e.target.result;
		        db.createObjectStore(ticketStorage, { keyPath: 'id' });
            };
        });
    },
    async setFiles(db, ticketNumber, files) {
        let obj = {
            id:  ticketNumber.toString(),
            files
        }
        return new Promise((resolve, reject) => {
            let trans = db.transaction([ticketStorage], 'readwrite');
            trans.oncomplete = e => {
                resolve();
            };
        
            let store = trans.objectStore(ticketStorage);
            store.delete(ticketNumber.toString());
            if (files && files.length > 0) {
                store.add(obj);
            }
        });
    },
    async addFile(db, ticketNumber, file) {
        let files = await this.getFiles(db, ticketNumber);
        files.push(file);
        return this.setFiles(db, ticketNumber, files);
    },
    async getFiles(db, ticketNumber) {
        return new Promise((resolve, reject) => {
            let files = [];

            let trans = db.transaction([ticketStorage],'readonly');
            trans.oncomplete = e => {
                resolve(files);
            };
            
            let store = trans.objectStore(ticketStorage);
            store.get(ticketNumber.toString()).onsuccess = e => {
                files = e.target.result ? e.target.result.files : [];
            }
        });
    },
}
export default QbIdb


// WEBPACK FOOTER //
// ./Components/idb/idb.js